export const SIZE_FILTER_ID = 'size';
export const COLOR_FILTER_ID = 'color';
export const PRICE_FILTER_ID = 'price';

export const UNALLOCATED_GROUP = 'unallocated';
export const SOLDOUT_GROUP = 'soldout';

export const PRICE_ASC = 'price_asc';
export const PRICE_ASC_NAME = 'По возрастанию цены';
export const PRICE_DESC = 'price_desc';
export const PRICE_DESC_NAME = 'По убыванию цены';
export const POPULARITY = 'popularity';
export const POPULARITY_NAME = 'По популярности';
export const NEWEST_FIRST = 'newest_first';
export const NEWEST_FIRST_NAME = 'По новизне';
export const DISCOUNT_DESC = 'discount_desc';
export const DISCOUNT_DESC_NAME = 'По скидке';

export const SORT_NAME_MAP = {
  [NEWEST_FIRST]: NEWEST_FIRST_NAME,
  [PRICE_ASC]: PRICE_ASC_NAME,
  [PRICE_DESC]: PRICE_DESC_NAME,
  [DISCOUNT_DESC]: DISCOUNT_DESC_NAME,
  [POPULARITY]: POPULARITY_NAME,
};

export const DEFAULT_SORT = POPULARITY;

// значения сортировок отзывов
export const NEW = 'published_at:desc';
export const OLD = 'published_at:asc';
export const RATING = 'rating:desc';
export const DEFAULT_REVIEW_SORT = NEW;
